import { Entity } from '../../../../../../../../@Api/Model/Implementation/Entity';
import useCampaignEmailStateCount from './useCampaignEmailStateCount';

export default function useCampaignTotalEmailCount(campaign: Entity)
{
    return useCampaignEmailStateCount(campaign);
}
